// extracted by mini-css-extract-plugin
module.exports = {"wrap":"sh-z","heading":"th-z","brandPromo":"uh-z"};